import { useShipmentCarrierControllerSearch } from 'services/openapi/apiComponents';
import { useNotification } from 'hooks/useNotification';

export const useShipmentCarriers = () => {
  const { showError } = useNotification();

  const { data, isLoading, error } = useShipmentCarrierControllerSearch(
    {},
    {
      staleTime: Infinity, // Data won't become stale
      cacheTime: 5 * 60 * 1000, // Cache for 5 minutes
      onError: () => {
        showError('Failed to fetch shipment carriers');
      },
    }
  );

  return {
    carriers: data?.items || [],
    loading: isLoading,
    error: error ? 'Failed to fetch shipment carriers' : null,
  };
};
